import type { DeepPartial } from '@luna/utils-ts';

import type { OwnTransfer } from './OwnTransfer';

export const HR: DeepPartial<OwnTransfer> = {
    enabledForLoans: true,
    isLoanAccountTransferAllowed: true,
    descriptionAttributeMapping: 'additionalInfo.text4x35[0]',
    descriptionMaxLength: 35,
    isDescriptionRequired: true,
};
